export default "__VITE_ASSET__BEmw_UoL__"